import REGEX from "./regex";

export default REGEX;
